module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-shop-banner-medium-080b4331a7dcbf33dbe30fb1a53ad194.jpg";